import { getIdToken } from "@/services/Auth";
import type { CreativeXDimensions, CreativeXSecret } from "@/types/preflight/creativeX";
import { getBaseApiUrl, getDefaultHeaders, request } from "@/utils/CreativeIntelligenceApi";
import { API_ROUTES } from "@/constants";

export async function getCreativeXDimensions(secretId?: string) {
    const baseUrl = getBaseApiUrl();

    const url = `${baseUrl}${API_ROUTES.CREATIVEX_DIMENSIONS}${secretId ? `?secretId=${secretId}` : ""}`;
    const token = await getIdToken();
    const headers = getDefaultHeaders(token);

    return request<CreativeXDimensions>(url, headers);
}

export async function getCreativeXSecrets() {
    const baseUrl = getBaseApiUrl();

    const url = `${baseUrl}${API_ROUTES.CREATIVEX_SECRETS}`;
    const token = await getIdToken();
    const headers = getDefaultHeaders(token);

    return request<CreativeXSecret[]>(url, headers);
}
